<!--
 * @Author: pengyong
 * @Date: 2020-12-09 20:23:43
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-09 20:26:35
 * @Description:
 * @FilePath: /exhibit/src/views/user/components/HeadLineTitle.vue
-->
<template>
    <div class="headline-title">
        <span @click="handleClick(1)" :class="[showChildId === 1 && 'active']">{{ $t("userCenter").collectVideo }}</span
        ><span @click="handleClick(2)" :class="[showChildId === 2 && 'active']">{{ $t("userCenter").collectZp }}</span
        ><span @click="handleClick(3)" :class="[showChildId === 3 && 'active']">{{ $t("userCenter").collectFile }}</span>
        <span @click="handleClick(7)" :class="[showChildId === 7 && 'active']">{{ $t("userCenter").collectExhibitors }}</span>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState(["showChildId"])
    },
    methods: {
        handleClick(id) {
            this.$store.commit("setState", {
                showChildId: id
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.headline-title {
    span {
        margin-right: 13px;
        color: rgba(9, 70, 140, 0.45);
        font-weight: 500;
        cursor: pointer;
        &.active {
            color: rgba(9, 70, 140, 1);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/HeadLineTitle.vue